import { render, staticRenderFns } from "./ModalContentMassMessage.vue?vue&type=template&id=0b0f86ee&scoped=true&"
import script from "./ModalContentMassMessage.vue?vue&type=script&lang=js&"
export * from "./ModalContentMassMessage.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentMassMessage.vue?vue&type=style&index=0&id=0b0f86ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0f86ee",
  null
  
)

export default component.exports